package com.exura.features.plandefinition.data.remote.dto.plan

import com.exura.features.firebase.data.remote.dto.SerializableDto
import kotlinx.serialization.Serializable

@Serializable
abstract class BasePlanDto : SerializableDto {
    abstract val title: String
    abstract val description: String
    abstract val durationInDays: Int?
    abstract val imageUrl: String?
}
